<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4.75 15.25H15.25C16.0784 15.25 16.75 14.5784 16.75 13.75V6.25C16.75 5.42157 16.0784 4.75 15.25 4.75H4.75C3.92157 4.75 3.25 5.42157 3.25 6.25V13.75C3.25 14.5784 3.92157 15.25 4.75 15.25Z"
    :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.11875 8.2375C6.46047 8.2375 6.7375 7.96047 6.7375 7.61875C6.7375 7.27703 6.46047 7 6.11875 7C5.77703 7 5.5 7.27703 5.5 7.61875C5.5 7.96047 5.77703 8.2375 6.11875 8.2375ZM8.59375 8.2375C8.93547 8.2375 9.2125 7.96047 9.2125 7.61875C9.2125 7.27703 8.93547 7 8.59375 7C8.25203 7 7.975 7.27703 7.975 7.61875C7.975 7.96047 8.25203 8.2375 8.59375 8.2375ZM11.0687 8.2375C11.4105 8.2375 11.6875 7.96047 11.6875 7.61875C11.6875 7.27703 11.4105 7 11.0687 7C10.727 7 10.45 7.27703 10.45 7.61875C10.45 7.96047 10.727 8.2375 11.0687 8.2375Z"
    :fill="stroke || 'currentColor'" :stroke="stroke || 'currentColor'" stroke-width="0.4125"/>
  </svg>
</template>

<script>
export default {
  name: 'BrandPlatformIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    stroke: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped></style>
